export default (conversation) => conversation.hasUnreadMessages
                || (!conversation.lastMessage?.read
                  && conversation.secondUser.type === conversation.lastMessage?.senderType);
